import { CurrentUserProfile } from '../../../interfaces/User';
import BusinessDocumentViewer from './BusinessDocumentViewer';
import { FileIcon } from '../../../components/icons/FileIcon';
import { truncate } from 'lodash';
import { Divider } from 'antd';

export const getDocumentNameAndExtension = (url: string) => {
    const parts = url.split('/');
    const lastPart = parts[parts.length - 1];
    const [filename, query] = lastPart.split('?');
    const [name, extension] = filename.split('.');
    return {
        name: truncate(name, {
            length: 40,
            omission: '...'
        }),
        extension
    };
};

const ProfileDocuments = ({
    userDetails
}: {
    userDetails: CurrentUserProfile;
}) => {
    const { documents } = userDetails;

    return (
        <div className='flex flex-col lg:max-w-[500px] max-w-[100%] w-full mx-auto lg:mx-0 mt-2 gap-[5px]'>
            <div className='flex flex-row justify-between items-center'>
                <h3 className='text-deepMidnightBlue text-[16px] font-[500]'>
                    Documents & Photos
                </h3>
            </div>

            <Divider className='my-2' />

            {documents && documents?.length > 0 && (
                <div className='flex gap-[10px] flex-col'>
                    {documents.map((document) => (
                        <div key={document.id}>
                            <p className='text-deepMidnightBlue text-[14px] py-2 font-[500]'>
                                {document.documentName}
                            </p>

                            <div className='min-h-[72px] p-3 flex items-center justify-between border border-primary500 bg-aliceBlue rounded-xl'>
                                <div className='flex w-full gap-2 items-center justify-between pr-2'>
                                    <div className='flex items-center'>
                                        <FileIcon />
                                        <div className='pl-4 col-span-9'>
                                            <p className='text-[#344054] text-[14px] font-[500]'>
                                                {
                                                    getDocumentNameAndExtension(
                                                        document.documentUrl
                                                    ).name
                                                }
                                            </p>
                                        </div>
                                    </div>

                                    <BusinessDocumentViewer
                                        url={document.documentUrl}
                                        ext={
                                            getDocumentNameAndExtension(
                                                document.documentUrl
                                            ).extension
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProfileDocuments;
